import request from '@wearetla/tla-essentials-tools/utilities/request';
import omit from 'lodash/omit';

const menuServices = {
	getBranchMenu: (branchSlug) => {
		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}`, false, (payload, status, request) => {
				if (payload?.categories) {
					resolve(payload.categories);
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
					);
				}
			});
		});
	},
	getMenuCategories: (branchSlug) => {
		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}`, false, (payload, status, request) => {
				if (payload?.menu?.merchants?.[0]) {
					resolve(
						payload.menu.merchants[0].menus.reduce((payload, menu) => {
							if(menu.products.length) {
								return [
									...payload,
									{
										...omit(menu, ['products']),
										product_count: menu.products?.length ?? 0,
									}
								]
							}

							return payload;
						}, [])
					);
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
					);
				}
			});
		});
	},
	getMenuCategory: (branchSlug, categoryId) => {
		return new Promise((resolve, reject) => {
			request.get(`menu/branch/${branchSlug}`, false, (payload, status, request) => {
				const menuCategory = (payload.menu?.merchants?.[0]?.menus ?? []).find(
					(menu) => menu.id.toString() === categoryId.toString()
				);
				if (menuCategory) {
					resolve(menuCategory);
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
					);
				}
			});
		});
	},
	getMenuProduct: (productId) => {
		return new Promise((resolve, reject) => {
			request.get(`menu/product/${productId}`, false, (payload, status, request) => {
				if (payload?.merchant_menu_product) {
					resolve({
						...payload.merchant_menu_product,
						category: payload.merchant_menu,
					});
				} else {
					reject(
						request?.data?.meta?.messages ||
							'Ürün getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
					);
				}
			});
		});
	},
	// getMenuSearchSuggestions: () => {
	// 	return new Promise((resolve, reject) => {
	// 		request.get(
	// 			`dummy/api/menu-search-suggestions.json`,
	// 			{},
	// 			(payload, status, request) => {
	// 				if (payload?.suggestions) {
	// 					resolve(payload.suggestions);
	// 				} else {
	// 					reject(
	// 						request?.data?.meta?.messages ||
	// 							'Arama sonuçları getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
	// 					);
	// 				}
	// 			},
	// 			{ static: true }
	// 		);
	// 	});
	// },
	// getMenuSearchHistory: () => {
	// 	return new Promise((resolve, reject) => {
	// 		request.get(
	// 			`dummy/api/menu-search-history.json`,
	// 			{},
	// 			(payload, status, request) => {
	// 				if (payload?.history) {
	// 					resolve(payload.history);
	// 				} else {
	// 					reject(
	// 						request?.data?.meta?.messages ||
	// 							'Arama geçmişi getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
	// 					);
	// 				}
	// 			},
	// 			{ static: true }
	// 		);
	// 	});
	// },
	// getMenuSearchResults: (branchSlug, query) => {
	// 	return new Promise((resolve, reject) => {
	// 		request.get(
	// 			`dummy/api/menu-search-results.json`,
	// 			{ query },
	// 			(payload, status, request) => {
	// 				if (payload?.results) {
	// 					resolve(payload);
	// 				} else {
	// 					reject(
	// 						request?.data?.meta?.messages ||
	// 							'Arama sonuçları getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
	// 					);
	// 				}
	// 			},
	// 			{ static: true }
	// 		);
	// 	});
	// },
	getMenuSearchResults: (branchSlug, query) => {
		return new Promise((resolve, reject) => {
			request.get(
				`menu/branch/${branchSlug}/products`,
				{ query },
				(payload, status, request) => {
					if (payload?.menu) {
						resolve({
							query,
							results: payload.menu,
					});
					} else {
						reject(
							request?.data?.meta?.messages ||
								'Arama sonuçları getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.'
						);
					}
				}
			);
		});
	},
};

export default menuServices;
